import React from "react";
import CollapsibleSection from "../CollapsibleSection";
import styles from "../ViewOptionsPanel.module.scss";

const ColumnChipSection = ({
  title = "Görüntülenen Sütunlar",
  columns = [],
  visibleColumns = [],
  onToggle,
  onReset,
  defaultOpen = true,
}) => (
  <CollapsibleSection
    title={title}
    defaultOpen={defaultOpen}
    headerAction={
      onReset ? (
        <button
          type="button"
          className={styles.sectionReset}
          onClick={(e) => {
            e.stopPropagation();
            onReset();
          }}
        >
          Sıfırla
        </button>
      ) : null
    }
  >
    <div className={styles.chipGrid} role="group" aria-label={title}>
      {columns.map((col) => {
        const active = visibleColumns.includes(col.id);
        return (
          <button
            key={col.id}
            type="button"
            className={`${styles.chip} ${active ? styles.chipActive : ""}`}
            aria-pressed={active}
            onClick={() => onToggle?.(col.id)}
          >
            {col.name}
          </button>
        );
      })}
    </div>
  </CollapsibleSection>
);

export default ColumnChipSection;
